import logo from './logo.svg';
import './App.css';
import RockBottomVillas from './RockBottom';

function App() {
  return (
    <RockBottomVillas/>
  );
}

export default App;
